import { Directive, ElementRef, HostListener, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { MediaFallbackService } from '../../services/media-fallback.service';

@Directive({
  selector: 'img[appMediaFallback]',
  standalone: true,
})
export class MediaFallbackDirective implements OnChanges, OnDestroy {
  @Input('appMediaFallback') filePath: string | null | undefined;
  @Input() appMediaFallbackAlternate: string | null | undefined;

  private fallbackIndex = 0;
  private activeObjectUrl: string | null = null;

  constructor(
    private elementRef: ElementRef<HTMLImageElement>,
    private mediaFallbackService: MediaFallbackService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filePath'] || changes['appMediaFallbackAlternate']) {
      this.fallbackIndex = 0;
      this.releaseActiveObjectUrl();
    }
  }

  ngOnDestroy(): void {
    this.releaseActiveObjectUrl();
  }

  @HostListener('error')
  async onImageError(): Promise<void> {
    const fallbackPaths = [this.filePath, this.appMediaFallbackAlternate].filter(
      (path): path is string => !!path
    );
    const nextPath = fallbackPaths[this.fallbackIndex];
    if (!nextPath) {
      return;
    }

    this.fallbackIndex++;

    try {
      const fallbackUrl = await this.mediaFallbackService.getFallbackObjectUrl(nextPath);
      if (!fallbackUrl) {
        return;
      }

      this.activeObjectUrl = fallbackUrl;
      this.elementRef.nativeElement.src = fallbackUrl;
    } catch (error) {
      console.warn('Media fallback failed for path:', this.filePath, error);
    }
  }

  private releaseActiveObjectUrl(): void {
    if (this.activeObjectUrl) {
      this.mediaFallbackService.releaseObjectUrl(this.activeObjectUrl);
      this.activeObjectUrl = null;
    }
  }
}
